module.exports = __webpack_public_path__ + "static/media/envelope.d2b39bd0.svg";